// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, update, create, get } from "./operations.js";
export {
  type ReplicationsListOptionalParams,
  type ReplicationsDeleteOptionalParams,
  type ReplicationsUpdateOptionalParams,
  type ReplicationsCreateOptionalParams,
  type ReplicationsGetOptionalParams,
} from "./options.js";
